export default "__VITE_ASSET__B2efDs9Y__"